var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fieldset", { staticClass: "customer-address-component" }, [
    _vm.locations.length && _vm.locations[0].address
      ? _c(
          "div",
          [
            _c("h3", { staticClass: "info" }, [
              _vm._v("\n      Select shipping address:\n    "),
            ]),
            _vm._v(" "),
            _c(
              "el-radio-group",
              {
                staticClass: "locations-group",
                on: {
                  input: function ($event) {
                    return _vm.selectRadioAddress()
                  },
                },
                model: {
                  value: _vm.location,
                  callback: function ($$v) {
                    _vm.location = $$v
                  },
                  expression: "location",
                },
              },
              _vm._l(_vm.locations, function (loc) {
                return _c(
                  "el-radio",
                  {
                    key: loc.location_id,
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: {
                      label: loc,
                      disabled: !_vm.isAllowedLocation(loc),
                    },
                  },
                  [
                    loc.address
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "Location not allowed, we cannot ship devices to this country",
                              placement: "top",
                              disabled: !!_vm.isAllowedLocation(loc),
                            },
                          },
                          [
                            _c("span", [
                              _c("b", [_vm._v(_vm._s(loc.name))]),
                              _vm._v(
                                " - " +
                                  _vm._s(loc.address.address1) +
                                  ", " +
                                  _vm._s(loc.address.address2) +
                                  " " +
                                  _vm._s(loc.address.city) +
                                  " " +
                                  _vm._s(loc.address.state) +
                                  " " +
                                  _vm._s(loc.address.country) +
                                  "\n          "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("p", [
              !_vm.showAddressForm
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.showNewAddressForm()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" Enter a different address\n      "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAddressForm
                ? _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          _vm.showAddressForm = false
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-s-fold" }),
                      _vm._v(" Hide address input\n      "),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showAddressForm,
            expression: "showAddressForm",
          },
        ],
      },
      [
        _c(
          "legend",
          [
            _c("el-switch", {
              attrs: { "active-text": "Google Places" },
              model: {
                value: _vm.googleOn,
                callback: function ($$v) {
                  _vm.googleOn = $$v
                },
                expression: "googleOn",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("GooglePlacesAddressForm", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentLocation,
              expression: "currentLocation",
            },
          ],
          ref: "addressForm",
          attrs: {
            autocomplete: _vm.googleOn,
            "current-address": _vm.currentLocation,
          },
          on: { update: _vm.onUpdate },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", { staticClass: "el-icon-phone" }),
      _vm._v(" "),
      _c("i", { staticClass: "el-icon-s-custom" }),
      _vm._v("\n      Confirm address with customer before proceeding\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }